export function PartsAuthorityOrderService (
  $q,
  $window,
  companyApi,
  sessionObjAPI,
  workshopAPI
) {
  var PartsAuthorityOrder = function (company, order) {
    this.Company        = companyApi;
    this.order          = order || {};
  };

  PartsAuthorityOrder.prototype.isValidVendor = function  () {
    const self     = this;
    const vendorId = sessionObjAPI.company().parts_authority_settings.parts_authority_vendor_id;

    return self.order.vendor_id &&
      self.Company.hasIntegration('parts-authority') &&
        vendorId === self.order.vendor_id;
  };

  PartsAuthorityOrder.prototype.send = function (order) {
    const self = this;

    return workshopAPI.post('/parts_authority/submit_order', order.id, 'purchase_order');
  };

  return PartsAuthorityOrder;
}
